export const configTransfers = [
  { id: 'companyname', header: 'Canjeador' },
  { id: 'phone', header: 'Contacto' },
  { id: 'address', header: 'Ubicación' },
  { id: 'description', header: 'Observación' }
]
